module.exports = __webpack_public_path__ + "media/toolkits/toolkits-analytics-small-d56ee113.png";